import React from "react"

interface Props extends React.ComponentPropsWithoutRef<"svg"> {
    size?: number | string
    style?: React.CSSProperties
    color?: string
    className?: string
}

export function ContactFarFAIcon({ size = 16, color, style, className, ...others }: Props) {
    return (
        <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fab"
            data-icon="contact"
            className={`svg-inline--fa fa-contact fa-w-10 fa-fw ${className}`}
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 14"
            color={color}
            style={{ width: size, height: size, ...style }}
            {...others}
        >
            <path
                fill="currentColor"
                d="M8.3125 0.65625C8.3125 0.300781 8.58594 0 8.96875 0H13.3164C13.6992 0 13.9727 0.300781 13.9727 0.65625V5.03125C13.9727 5.41406 13.6992 5.6875 13.3164 5.6875C12.9609 5.6875 12.6602 5.41406 12.6602 5.03125V2.24219L6.5625 8.33984C6.31641 8.61328 5.90625 8.61328 5.66016 8.33984C5.38672 8.09375 5.38672 7.68359 5.66016 7.41016L11.7578 1.3125H8.96875C8.58594 1.3125 8.3125 1.03906 8.3125 0.65625ZM1.96875 0.875H5.46875C5.82422 0.875 6.125 1.17578 6.125 1.53125C6.125 1.91406 5.82422 2.1875 5.46875 2.1875H1.96875C1.58594 2.1875 1.3125 2.48828 1.3125 2.84375V12.0312C1.3125 12.4141 1.58594 12.6875 1.96875 12.6875H11.1562C11.5117 12.6875 11.8125 12.4141 11.8125 12.0312V8.53125C11.8125 8.17578 12.0859 7.875 12.4688 7.875C12.8242 7.875 13.125 8.17578 13.125 8.53125V12.0312C13.125 13.125 12.2227 14 11.1562 14H1.96875C0.875 14 0 13.125 0 12.0312V2.84375C0 1.77734 0.875 0.875 1.96875 0.875Z"
            />
        </svg>
    )
}
